var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ChangeReseller',{ref:"changeReseller",attrs:{"type":"lead"},on:{"modelChanged":function($event){return _vm.$emit('modelChanged', $event)}}}),_c('confirm-delete',{ref:"confirmDelete"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }